import React, { createContext, useContext, useEffect, useState } from 'react';
import {
  auth, googleProvider,
  signInWithPopup, signInWithEmailAndPassword, createUserWithEmailAndPassword,
  signOut, onAuthStateChanged, updateProfile, User,
} from '../lib/firebase';

interface AuthContextValue {
  user: User | null; loading: boolean;
  loginWithGoogle: () => Promise<void>;
  loginWithEmail: (email: string, password: string) => Promise<void>;
  registerWithEmail: (name: string, email: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
}
const AuthContext = createContext<AuthContextValue | null>(null);

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => { const u = onAuthStateChanged(auth, u => { setUser(u); setLoading(false); }); return u; }, []);
  const loginWithGoogle = async () => { await signInWithPopup(auth, googleProvider); };
  const loginWithEmail = async (email: string, password: string) => { await signInWithEmailAndPassword(auth, email, password); };
  const registerWithEmail = async (name: string, email: string, password: string) => {
    const cred = await createUserWithEmailAndPassword(auth, email, password);
    await updateProfile(cred.user, { displayName: name });
  };
  const logout = async () => { await signOut(auth); };
  return <AuthContext.Provider value={{ user, loading, loginWithGoogle, loginWithEmail, registerWithEmail, logout }}>{children}</AuthContext.Provider>;
}
export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be inside AuthProvider');
  return ctx;
}
